import { getErrorMessage } from 'application/util/error.util';

import template from './email-verification-request.tpl.pug';

class EmailVerificationRequestController {
    /* @ngInject */
    constructor($state, emailVerificationService) {
        this.$state = $state;
        this.emailVerificationService = emailVerificationService;
    }

    send(email) {
        return this.emailVerificationService.send(email).then(() => {
            this.$state.go('identity.email-verification.confirm');
        }, (result) => {
            this.error = getErrorMessage(result, `We were not able to verify your email address.`);
        });
    }
}

export default {
    selector: 'dbAEmailVerificationRequest',
    template: template(),
    controller: EmailVerificationRequestController,
    bindings: {
        email: '<',
        error: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/email-verification/scene/email-verification-request/email-verification-request.cmpt.js